export enum AuthSource {
  Spx = '1',
  SpxStaff = '2',
}
